// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    createHandlerChainRunner,
    Handler,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import translate from "@insite/client-framework/Translate";
import { RfqFormApiParameter, submitForm } from "@sc/App/Services/RfqService";
import { ErrorApiDefaultMessage } from "@sc/XDL/constants";

type Parameter = {
    rfqForm: RfqFormApiParameter;
    onSuccess?: () => void;
    onError?: (error: string) => void;
};

type Props = {
    apiParameter: any;
    apiResult: any;
};

type HandlerType = Handler<Parameter, Props>;

export const SendDataToApi: HandlerType = async props => {
    try {
        props.apiResult = await submitForm(props.parameter.rfqForm);
    } catch (error) {
        const failedMessage = error.errorMessage || translate(ErrorApiDefaultMessage);
        props.parameter.onError?.(failedMessage);
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [
    SendDataToApi,
    ExecuteOnSuccessCallback,
];

const submitRfqForm = createHandlerChainRunner(chain, "submitRfqForm");

export default submitRfqForm;
